import { DatabaseRecord } from "../repos/table.repo";
import { ContractModel } from "./contracts/contract.model";
import { TollAreaModel } from "./toll-area/toll-area.model";

interface WaterIndexModelExt {
    tollArea?: TollAreaModel
}

export interface WaterIndexHistory {
    id: string;
    waterUserId: string;
    waterMeterNumber?: number | null;
    oldNumber?: number | null;
    useAmount?: number | null;
    year: number;
    month: number;
    createdAt?: string | null;
    image?: string | null;
    note?: string | null;
}

export interface WaterIndexModel extends DatabaseRecord, WaterIndexModelExt {
    year: number;
    month: number;
    waterUserId: string;
    waterMeterNumber?: number | null;
    waterMeterCode?: string | null;
    image?: string | null;
    createdAt?: Date;
    createdBy: string;
    updatedAt?: Date;
    updatedBy: string;
    waterFactoryId: string;
    tollAreaId?: string;
    waterUser?: ContractModel;
    note?: string | null;
    latitude: number;
    longtitude: number;
    oldNumber?: number | null;
    useAmount?: number | null;
    oldUseAmount?: number | null;
    differenceRatio?: number | null;
    status?: string;
    isReverseRotated?: boolean | null;
    isFullRotation?: boolean | null;
    waterMeterMaxIndex?: number | null;
    hasInvoice?: boolean | null;
    previousIndexes?: WaterIndexHistory[] | null;
}

export class WaterIndexModelFactory {
    static getEmpty(): WaterIndexModel {
        return {
            id: "",
            year: 0,
            month: 0,
            waterUserId: "",
            waterMeterCode: "",
            waterMeterNumber: undefined,
            image: "",
            createdBy: "",
            updatedBy: "",
            waterFactoryId: "",
            tollAreaId: "",
            waterUser: {} as ContractModel,
            note: "",
            latitude: 0,
            longtitude: 0,
            oldNumber: undefined,
            useAmount: undefined
        };
    }
}